// 登陆，退出
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
// 商家
export const TRADESMANLOGIN = 'TRADESMANLOGIN'
export const TRADESMANLOGOUT = 'TRADESMANLOGOUT'
